import { render, staticRenderFns } from "./upload-files.vue?vue&type=template&id=553bbd66&scoped=true&"
import script from "./upload-files.vue?vue&type=script&lang=js&"
export * from "./upload-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553bbd66",
  null
  
)

export default component.exports